<template>

  <div class="productCatalog">
    <div class="container">

        <div class="row">
            <div class="col"><hr></div>
            <div class="col-auto primaryHeading">Ein.Blick in unsere Gewächshäuser</div>
            <div class="col"><hr></div>
        </div>

        <img class="mainBanner" :src="url + '/Banner.png'" crossorigin="anonymous" />
        <!-- <img class="gardneryImage" src="/Gaertnerei.jpg" /> -->


        <nav id="mainNavbar" class="navbar navbar-expand-lg navbar-light bg-light sticky-top">
            <a class="navbar-brand" href="#">
                <img :src="url + '/Hoeller_blume.png'" width="30" height="30" class="d-inline-block align-top" alt="" crossorigin="anonymous">
                Gärtnerei Höller
            </a>
                <form class="form-inline my-2 my-lg-0" action="javascript:myFunction(); return false;"> <!-- onsubmit="return false;" -->
                    <input class="form-control mr-sm-2 searchTextfield" type="text" v-model="search" v-on:keyup="openQuickJumpList" placeholder="Suche"/>
                    <div id="quickJumpList_dd" class="dropdown">
                        <button class="btn btn-primary" type="button" id="quickJumpList_ddbtn" aria-haspopup="true" aria-expanded="false"  data-toggle="dropdown" data-placement="top" title="Klick mich, um schnell zu den Artikeln springen zu können!">
                            <span>
                                <div class="productFilterCountText">{{filteredProductsCount}} Artikel</div>
                                <div class="productFilterCountText">in {{filteredProductCategories.length}} Kategorien</div>
                            </span>
                            <i class="fa fa-caret-down"></i>
                        </button>
                        <div id="categoryJumpList" class="dropdown-menu pre-scrollable">

                            <form>
                            <a class="dropdown-item" href="#sortiment">zum Anfang</a>
                            <div class="dropdown-divider"></div>
                                <a class="dropdown-item" v-for="(category, i) in filteredProductCategories" :key="category.key" :href="'#' + category.key">
                                    <span v-if="i == 0 || (i > 0 && category.name[0] != filteredProductCategories[i-1].name[0])"><span class="quickJumpProductFirstLetter">{{category.name[0]}}</span><span>{{category.name.substring(1)}}</span><span class="quickJumpProductCount" v-if="category.filteredProducts.length > 1"> ({{category.filteredProducts.length}})</span></span>
                                    <span v-else>{{category.name}}<span class="quickJumpProductCount" v-if="category.filteredProducts.length > 1"> ({{category.filteredProducts.length}})</span></span>

                                </a>
                            </form>
                        </div>
                    </div>
                </form>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <a class="nav-link" href="#filter">Filter</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="#wishlist">Merkliste ({{wishlist.length}})</a>
                    </li>
                </ul>
                <ul class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <a class="nav-link" target="_blank" href="https://gaertnerei-am-berg.at">Homepage</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" target="_blank" href="https://gaertnerei-am-berg.at/index.php/contact">Kontakt</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" target="_blank" href="mailto:office@gaertnerei-am-berg.at">Email</a>
                    </li>
                </ul>
            </div>
        </nav>

        <div>

            <div class="searchHeadingPlaceholder"> </div>

            <div class="filterPanel">
                <h3 id="filter">Filter:</h3>
                <div class="row">
                    <!--
                    <div class="col-md-3">
                        <h6>Artikelgruppen</h6>
                        <div class="form-check" v-for="productGroup in distinctProductGroups" :key="productGroup">
                            <input v-model="checkedProductGroups[productGroup]" class="form-check-input" type="checkbox" :id="productGroup + '_group_filter'" name="productgroup_filters">
                            <label class="form-check-label" :for="productGroup + '_group_filter'">
                                {{productGroup}}
                            </label>
                        </div>
                    </div>
                    -->
                    <div class="col-md-3">
                        <h6>Pflanzenkategorien</h6>
                        <div class="form-check" v-for="plantCategory in distinctPlantCategories" :key="plantCategory">
                            <input v-model="checkedPlantCategories[plantCategory]" class="form-check-input" type="checkbox" :id="plantCategory + '_group_filter'" name="plantcategory_filters">
                            <label class="form-check-label" :for="plantCategory + '_group_filter'">
                                {{plantCategory}}
                            </label>
                        </div>
                    </div>

                    <div class="col-md-1">
                        <h6>Topf</h6>
                        <div class="form-check" v-for="pot in distinctPots" :key="pot">
                            <input v-model="checkedPots[pot]" class="form-check-input" type="checkbox" :id="pot + '_pot_filter'">
                            <label class="form-check-label" :for="pot + '_pot_filter'">
                                {{pot}}
                            </label>
                        </div>
                    </div>

                    <div class="col-md-2">
                        <h6>Verfügbarkeit</h6>
                        <div class="form-check">
                            <input v-model="checkedAvailability.available" class="form-check-input" type="checkbox" id="available_availability_filter" />
                            <label class="form-check-label" for="available_availability_filter">
                                lagernd
                            </label>
                        </div>
                        <div class="form-check">
                            <input v-model="checkedAvailability.soon" class="form-check-input" type="checkbox" id="soon" />
                            <label class="form-check-label" for="soon">
                                bald verfügbar
                            </label>
                        </div>
                        <hr />
                        <div class="form-check">
                            <input v-model="checkedAvailability.seasonProductsOnly" class="form-check-input" type="checkbox" id="seasonProductsOnly_availability_filter" />
                            <label class="form-check-label" for="seasonProductsOnly_availability_filter">
                                nur Saisonartikel
                            </label>
                        </div>
                    </div>

                    <div class="col-md-2">
                        <h6>produziert aus</h6>
                        <div class="form-check" v-for="seed in distinctSeeds" :key="seed">
                            <input v-model="checkedSeeds[seed]" class="form-check-input" type="checkbox" :id="seed + '_seed_filter'">
                            <label class="form-check-label" :for="seed + '_seed_filter'">
                                {{seed}}
                            </label>
                        </div>
                    </div>

                    <!--
                    <div class="col-md-4">
                        <h6>Verwendungen</h6>
                        <div class="form-check" v-for="usage in distinctProductUsages" :key="usage">
                            <input v-model="checkedProductUsages[usage]" class="form-check-input" type="checkbox" :id="usage + '_usage_filter'" name="productusage_filters">
                            <label class="form-check-label" :for="usage + '_usage_filter'">
                                {{usage}}
                            </label>
                        </div>
                    </div>
                    -->
                </div>
            </div>
        </div>

        <div v-if="filteredAdProducts.length > 0">
            <h2 class="newProductHeader">Aufgeschnappt...</h2>
            <div class="row">
                <div v-for="product in filteredAdProducts" :key="product.key" class="card newProductCard" style="width: 18rem;">
                    <img class="card-img-top" :src="productThumbnail(product)" alt="kein aktuelles Foto vorhanden" crossorigin="anonymous">

                    <div class="card-body">
                        <h5 class="card-title">{{product.name}}</h5>
                        <p class="card-text">{{product.pot}} | <span v-for="(productGroup,index) in product.productGroups" :key="productGroup"> {{productGroup}}<span v-if="index+1 < product.productGroups.length">, </span></span></p>
                        <p v-if="product.adNew.trim().length > 0" class="newProductText">{{product.adNew}}</p>
                        <p v-if="product.adForSale.trim().length > 0" class="forSaleProductText">{{product.adForSale}}</p>
                        <p v-if="product.adSpotlight.trim().length > 0" class="spotlightProductText">{{product.adSpotlight}}</p>
                        <button type="button" class="btn btn-secondary" data-toggle="modal" v-on:click="viewImageDetails_click(product)" data-target="#productDetailsModal">ansehen</button>
                        <button type="button" class="btn btn-light" v-if="!isInWishlist(product)" v-on:click="saveToWishlist(null, product)">merken</button>
                        <button type="button" class="btn btn-success" v-else v-on:click="saveToWishlist(null, product)">gemerkt</button>
                    </div>
                </div>

            </div>
        </div>

        <div class="row">
            <div class="col"><hr></div>
            <div id="sortiment" class="col-auto sortimentHeader">unser Sortiment</div>
            <div class="col"><hr></div>
        </div>
        <div class="row">
            <div class="col-md-8">

                <div class="row" v-for="category in filteredProductCategories" :key="category.key" data-spy="scroll"  data-target="#mainNavbar" data-offset="0">
                    <a class="anchor" :id="category.key"></a>
                    <h3 class="productGroupHeading" style="margin-top: 50px; margin-bottom: 20px">{{category.name}}</h3>
                    <div class="container">

                        <div class="row productCard" v-for="product in category.filteredProducts" :key="product.key">
                            <div class="media" :id="product.key">
                                <div class="productCardLeftPanel">
                                    <img style="max-width: 300px; max-height: 150px;" class="mr-3 productCardImage"
                                      :src="productThumbnail(product)" alt="kein aktuelles Bild..." data-toggle="modal" v-on:click="viewImageDetails_click(product)" data-target="#productDetailsModal" crossorigin="anonymous" />

                                    <div class="productButtonsPanel">
                                        <button type="button" class="btn btn-secondary" data-toggle="modal" v-on:click="viewImageDetails_click(product)" data-target="#productDetailsModal">Fotos</button>
                                        <button type="button" class="btn btn-light" v-if="!isInWishlist(product)" v-on:click="saveToWishlist(category, product)">merken</button>
                                        <button type="button" class="btn btn-success" v-else v-on:click="saveToWishlist(category, product)">gemerkt</button>
                                    </div>

                                    <!-- Modal -->
                                    <div class="modal fade" id="productDetailsModal" tabindex="-1" role="dialog" aria-labelledby="productDetailsModalLabel" aria-hidden="true">
                                        <div class="modal-dialog modal-lg" role="document">
                                            <div class="modal-content">
                                                <div class="modal-header">
                                                    <h5 class="modal-title" id="productDetailsModalLabel">{{productDetails.product.name}}</h5>
                                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div class="modal-body">
                                                    <div>
                                                        <p>{{productDetails.product.pot}} | {{productDetails.product.seed}} | <span v-for="(productGroup,index) in productDetails.product.productGroups" :key="productGroup"> {{productGroup}}<span v-if="index+1 < product.productGroups.length">, </span></span></p>
                                                    </div>

                                                    <ul class="nav nav-tabs" role="tablist">
                                                        <li class="nav-item" >
                                                            <a class="nav-link active" id="currentImages-tab" data-toggle="tab" href="#currentImagesTabContent" role="tab" aria-controls="currentImagesTabContent" aria-selected="true">Fotos aus dem Gewächshaus ({{productDetails.images.length}})</a>
                                                        </li>
                                                        <li class="nav-item" >
                                                            <a class="nav-link" id="symbolImages-tab" data-toggle="tab" href="#symbolImagesTabContent" role="tab" aria-controls="symbolImagesTabContent" aria-selected="false">Symbolfotos ({{productDetails.symbolImages.length}})</a>
                                                        </li>
                                                    </ul>
                                                    <div class="tab-content">
                                                        <div class="tab-pane fade show active" id="currentImagesTabContent" role="tabpanel" aria-labelledby="currentImages-tab">
                                                            <div id="carouselCurrentImagesIndicators" class="carousel slide carousel-fade" data-ride="carousel">
                                                                <ol class="carousel-indicators">
                                                                    <li v-for="(image, index) in productDetails.images" :key="index" data-target="#carouselCurrentImagesIndicators" :data-slide-to="index" :class="index == 0 && 'active'"></li>
                                                                </ol>
                                                                <div class="carousel-inner">
                                                                    <div v-for="(image, index) in productDetails.images" :key="image.url" class="carousel-item productDetailsImageHolder" :class="index == 0 && 'active'">
                                                                        <img class="d-block productDetailsImage" :src="image.url" :alt="index" crossorigin="anonymous">
                                                                        <div v-if="ageInWeeks(image) !== undefined" class="carousel-caption d-none d-md-block imageCaption" :class="ageInWeeks(image) > 0 && 'warning'">
                                                                            <h5 class="imageCaptionHeading">Bild {{index + 1}}</h5>
                                                                            <p class="imageCaptionText" v-if="ageInWeeks(image) > 0">... Foto ist <span class="imageAgeWeek">{{ageInWeeks(image)}} Wochen </span> alt!</p>
                                                                            <p class="imageCaptionText" v-else>aktuelles Foto</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                
                                                                <a class="carousel-control-prev imageDetailsNavButton" href="#carouselCurrentImagesIndicators" role="button" data-slide="prev">
                                                                    <span class="carousel-control-prev-icon navIcon" aria-hidden="true"></span>
                                                                    <span class="sr-only">Previous</span>
                                                                </a>
                                                                <a class="carousel-control-next imageDetailsNavButton" href="#carouselCurrentImagesIndicators" role="button" data-slide="next">
                                                                    <span class="carousel-control-next-icon navIcon" aria-hidden="true"></span>
                                                                    <span class="sr-only">Next</span>
                                                                </a>
                                                            
                                                            </div>
                                                        </div>
                                                        <div class="tab-pane fade" id="symbolImagesTabContent" role="tabpanel" aria-labelledby="symbolImages-tab">
                                                            <div id="carouselSymbolImagesIndicators" class="carousel slide carousel-fade" data-ride="carousel">
                                                                <ol class="carousel-indicators">
                                                                    <li v-for="(image, index) in productDetails.symbolImages" :key="index" data-target="#carouselSymbolImagesIndicators" :data-slide-to="index" :class="index == 0 && 'active'"></li>
                                                                </ol>
                                                                <div class="carousel-inner">
                                                                    <div v-for="(image, index) in productDetails.symbolImages" :key="image.url" class="carousel-item productDetailsImageHolder" :class="index == 0 && 'active'">
                                                                        <img class="d-block productDetailsImage" :src="image.url" :alt="index" crossorigin="anonymous">
                                                                        <div v-if="ageInWeeks(image) !== undefined" class="carousel-caption d-none d-md-block imageCaption" :class="ageInWeeks(image) > 0 && 'warning'">
                                                                            <h5 class="imageCaptionHeading">Bild {{index + 1}}</h5>
                                                                            <p class="imageCaptionText" v-if="ageInWeeks(image) > 0">... Foto ist <span class="imageAgeWeek">{{ageInWeeks(image)}} Wochen </span> alt!</p>
                                                                            <p class="imageCaptionText" v-else>aktuelles Foto</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                
                                                                <a class="carousel-control-prev imageDetailsNavButton" href="#carouselSymbolImagesIndicators" role="button" data-slide="prev">
                                                                    <span class="carousel-control-prev-icon navIcon" aria-hidden="true"></span>
                                                                    <span class="sr-only">Previous</span>
                                                                </a>
                                                                <a class="carousel-control-next imageDetailsNavButton" href="#carouselSymbolImagesIndicators" role="button" data-slide="next">
                                                                    <span class="carousel-control-next-icon navIcon" aria-hidden="true"></span>
                                                                    <span class="sr-only">Next</span>
                                                                </a>
                                                            
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <!--<div class="modal-footer">-->
                                                    <!--<button type="button" class="btn btn-secondary" data-dismiss="modal">Schließen</button>-->
                                                <!--</div>-->
                                            </div>
                                        </div>
                                    </div>
                                </div> <!-- /media left side ? -->

                                <div class="media-body productCardContent">
                                    <div class="container">

                                        <div class="row productName">
                                            <h4 class="mt-0" :id="product.key">{{product.name}}</h4>
                                        </div>
                                        <div class="row">
                                            <span class="botanicName">{{product.botanicName}}</span>
                                        </div>

                                        <div class="row productMainInfoLine">
                                            <p>{{product.pot}}<span v-if="product.seed != null"><span class="potSeedProductGroupsSeparator"> | </span>{{product.seed}}</span><span class="potSeedProductGroupsSeparator"> | </span><span>{{product.plantCategory}}</span><!--<span class="potSeedProductGroupsSeparator"> | </span><span v-for="(productGroup,index) in product.productGroups" :key="productGroup"> {{productGroup}}<span v-if="index+1 < product.productGroups.length">, </span></span>--></p>
                                        </div>
                                        <!--
                                        <div class="row productCardRow">
                                            <div class="productCardInfo">
                                                <div class="productCardLabel"><span class="productCardInfo"> </span>Verwendung:</div>
                                                <span v-for="(usage,index) in product.usages" :key="usage"> {{usage}}<span v-if="index+1 < product.usages.length">, </span></span></div>
                                        </div>
                                        -->

                                        <div class="row" v-if="product.availability.status >= 0">
                                            <div class="productCardRow"> <!--  v-if="product.availability.text.length > 0" -->
                                                <div class="productCardLabel"><span class="productCardInfoAvailability"> </span>Verfügbarkeit:</div>
                                                <div class="productCardInfoAvailability" :class="product.availability.status == 4 && 'availabilityWarning' || product.availability.status == 3 && 'availabilityGood' || product.availability.status == 2 && 'availabilitySoon' || product.availability.status == 1 && 'availabilitySoldOut' || product.availability.status == 0 && 'availabilityOffSeason'">

                                                    <span v-if="product.availability.status === 0">außerhalb der Saison</span>
                                                    <span v-else-if="product.availability.status === 1">für diese Saison ausverkauft</span>
                                                    <span v-else-if="product.availability.status === 2">

                                                        <span v-if="product.availability.status === 2 && availableInWeeksText(product) != null">{{availableInWeeksText(product)}}</span>
                                                        <span v-else>derzeit nicht verfügbar</span>
                                                    </span>
                                                    <span v-else-if="product.availability.status === 3">verfügbar</span>
                                                    <span v-else-if="product.availability.status === 4">~ </span>
                                                    <span v-else></span>


                                                    <span v-if="product.availability.text.trim().length > 0">
                                                        <span v-if="product.availability.status !== 4"> - </span>
                                                        <span>{{product.availability.text}}</span>
                                                    </span>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="row" v-if="product.availability.status == 0">
                                            <div class="productCardRow">
                                                <div class="productCardLabel"><span class="productCardInfoAvailability"> </span>Saison:</div>
                                                <div class="productCardInfoAvailability" :class="product.availability.status == 0 && 'availabilityOffSeason'">{{product.availability.season.text}}</div>
                                            </div>
                                        </div>
                                    </div>

                                </div> <!-- /media-body -->

                            </div> <!-- /media -->


                            <div class="container">
                                <div class="row">
                                    <hr />
                                    <div :class="customerProductNumber(product) !== undefined ? 'col-md-4' : 'col-md-6'" class="productOrderNumberPanel bottom-align-text">
                                        <div class="productOrderNumberPanelNumber">{{product.productOrderNumber}}</div>
                                        <div class="productCardNumberLabel">Artikel-BestellNr.</div>
                                    </div>
                                    <div class="col-md-4 customerProductNumberPanel bottom-align-text" v-if="customerProductNumber(product) !== undefined">
                                        <div class="customerProductNumberPanelNumber"><span class="productOrderNumberPanelNumber"> </span>{{customerProductNumber(product)}}</div>
                                        <div class="productCardNumberLabel">Kunden-ArtikelNr.</div>
                                    </div>
                                    <div :class="customerProductNumber(product) !== undefined ? 'col-md-4' : 'col-md-6'" class="col-md-4 eanPanel bottom-align-text">

                                        <div class="eanPanelNumber"><span class="productOrderNumberPanelNumber"> </span>
                                            <span v-if="product.ean.trim().length > 0">{{product.ean}}</span>
                                            <span v-else>?</span>
                                        </div>
                                        <div class="productCardNumberLabel">EAN</div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>


            <div class="col-md-4">

                <div class="wishlist">

                    <h1 id="wishlist">Merkliste</h1>
                    <div class="wishlistButtonsPanel">
                        <button type="button" :disabled="wishlist.length <= 0" class="btn btn-primary" data-toggle="modal" data-target="#wishlistModal">
                            Merkliste kopieren
                        </button>
                    </div>

                    <div v-for="wishlistItem in wishlist" :key="wishlistItem.product.productOrderNumber" class="wishlistItem" data-toggle="modal" v-on:click="viewImageDetails_click(wishlistItem.product)" data-target="#productDetailsModal">
                        <button type="button" class="btn btn-light btn-sm" v-on:click="removeFromWishlist(wishlistItem)">X</button>
                        <span>{{wishlistItem.product.name}} {{wishlistItem.product.pot}}</span>
                    </div>

                </div>
            </div> <!-- wishlist -->
        </div>
    </div>

    <div class="modal fade wishlistCopyModal" id="wishlistModal" tabindex="-1" role="dialog" aria-labelledby="wishlistModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="wishlistModalLabel">Merkliste</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div>
                        <textarea id="wishlist_textarea" style="width: 100%; height: 400px;"></textarea><!--display: none;-->
                    </div>
                    <button class="btn btn-primary" v-on:click="copyWishlist">Merkliste kopieren</button>
                    <a class="btn btn-secondary" :href="'mailto:office@gaertnerei-am-berg.at?body=' + wishlistText">Sende Email</a>
                    <p>{{wishlistCopyMessage}}</p>
                </div>
                <!--<div class="modal-footer">-->
                    <!--<button type="button" class="btn btn-secondary" data-dismiss="modal">Schließen</button>-->
                <!--</div>-->
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductCatalog',
  props: {
    msg: String
  },
  data: function() {
    return {
        url: 'https://hoeller-gartenbau.at',
        // url: '.',
        customerLink: null,
        currentWeekNumber: null,
        search: "",
        checkedAvailability: { available: false, soon: false, seasonProductsOnly: true },
        checkedPots: {},
        checkedSeeds: {},
        checkedProductGroups: {},
        checkedProductUsages: {},
        checkedOrigins: { inhouse: false, austria: false, eu: false, world: false },
        distinctPlantCategories: [],
        checkedPlantCategories: {},
        distinctProductGroups: [],
        distinctProductUsages: [],
        distinctPots: [],
        distinctSeeds: [],
        wishlist: [],
        wishlistText: "",
        wishlistCopyMessage: "",
        productDetails: {
            product: {},
            images: [],
            symbolImages: []
        },
        showImages: 'none',
        noImageUrl: "",
        customerKeys: { c1: "1", c2: "2", c3: "3" , c4: "4", c5: "5" },
        productCategories: [],
        products: [],
        customerProductSpecifics: {}
     };
  },
  methods: {


      ageInWeeks: function(image) {
          if (image.weekTaken === undefined) {
              return undefined;
          } else {
              return this.currentWeekNumber - image.weekTaken;
          }
      },

      // https://stackoverflow.com/a/6117889/6603778
      getWeekNumber: function(d) {
        d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
        d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay()||7));
        var yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
        var weekNo = Math.ceil(( ( (d - yearStart) / 86400000) + 1)/7);
        return weekNo;
    },
      availableInWeeksText: function(product) {
          if (product.availability.nextBatch == null || product.availability.nextBatch.inWeek == null) {
              return null;
          } else {
              let weeksLeft = product.availability.nextBatch.inWeek - this.currentWeekNumber;
              return "in ca. " + weeksLeft + " Wochen wieder verfügbar";
          }
      },
      customerProductNumber: function(product) {
          if (product.productOrderNumber in this.customerProductSpecifics) {
              return this.customerProductSpecifics[product.productOrderNumber].customerProductNumber;
          } else {
              return undefined;
          }
      },
      customerProductNumberLowerCase: function(product) {
          if (product.productOrderNumber in this.customerProductSpecifics) {
              return this.customerProductSpecifics[product.productOrderNumber].customerProductNumber.toLowerCase();
          } else {
              return undefined;
          }
      },
      isSeason: function(product) {
          let week = this.currentWeekNumber;

          // console.log(JSON.stringify(product));
          let a = product.visibility;
          if (a.from <= a.to) {
              // console.log("is season for " + product.name + ": " + a.from + " <= " + week + " <= " + a.to);
              return a.from <= week && week <= a.to;
          } else {
              // return week >= a.from || a.to >= week
              // console.log("is season for " + product.name + ": " + a.from + " <= " + week + " <= " + a.to + " ***");
              return week <= Math.min(a.from, a.to) || week >= Math.max(a.from, a.to);
          }
          // product.availability.season.from <= week && week <= product.availability.season.to
      },
      filterProducts: function(productList, categoryKey, searchstring, categoryMatches) {

          // console.log(JSON.stringify(productList));

              return productList.filter(product => {
                  // console.log("name='" + product.name + "': " + JSON.stringify(product));
                  // console.log("name='" + product.name + "'");

                      const productName = product.name.toLowerCase();
                    const botanicName = product.botanicName.toLowerCase();
                  const ean = product.ean;
                      const productOrderNumber = product.productOrderNumber.toLowerCase();
                      const customerProductNumber = this.customerProductNumberLowerCase(product);

                      return product.categoryKey == categoryKey &&
                           (searchstring == ''
                          || productName.includes(searchstring)
                          || botanicName.includes(searchstring)
                          || product.alternativeNames.some(elem => elem.toLowerCase().includes(searchstring))
                          || ean.includes(searchstring)
                          || productOrderNumber.includes(searchstring)
                          || customerProductNumber == searchstring
                          || categoryMatches)
                          && (this.distinctPots.every(i => !this.checkedPots.hasOwnProperty(i) || !this.checkedPots[i])
                                || this.checkedPots[product.pot])
                          && (this.distinctSeeds.every(i => !this.checkedSeeds.hasOwnProperty(i) || !this.checkedSeeds[i])
                                || this.checkedSeeds[product.seed])
                          && (this.distinctPlantCategories.every(i => !this.checkedPlantCategories.hasOwnProperty(i) || !this.checkedPlantCategories[i])
                              || this.checkedPlantCategories[product.plantCategory])
                          // && (this.distinctProductGroups.every(i => !this.checkedProductGroups.hasOwnProperty(i) || !this.checkedProductGroups[i])
                          //       || product.productGroups.some(i => this.checkedProductGroups[i]))
                          && (!this.checkedAvailability.available && !this.checkedAvailability.soon && !this.checkedAvailability.seasonProductsOnly
                                || (((this.checkedAvailability.seasonProductsOnly && (product.availability.status > 0 || this.isSeason(product)))
                                        || !this.checkedAvailability.seasonProductsOnly)
                                    && (!this.checkedAvailability.available && !this.checkedAvailability.soon
                                    || this.checkedAvailability.available && [4, 3].includes(product.availability.status)
                                    || this.checkedAvailability.soon && product.availability.status == 2
                                    || this.checkedAvailability.available && this.checkedAvailability.soon
                                                && [4, 3, 2].includes(product.availability.status))))
                          && (!this.checkedOrigins.inhouse && !this.checkedOrigins.austria && !this.checkedOrigins.eu && !this.checkedOrigins.world
                                || this.checkedOrigins.inhouse && product.origin.type == 'Eigenproduktion'
//                                    || this.checkedOrigins.austria && ['Eigenproduktion'].includes(product.origin.type)
                                || this.checkedOrigins.austria && product.origin.type == 'Österreich'
//                                    || this.checkedOrigins.eu && ['Eigenproduktion', 'Österreich', 'EU'].includes(product.origin.type)
                                || this.checkedOrigins.eu && product.origin.type == 'EU'
                                || this.checkedOrigins.world && product.origin.type == 'World')
                          && (this.distinctProductGroups.every(i => !this.checkedProductGroups.hasOwnProperty(i) || !this.checkedProductGroups[i])
                                || product.productGroups.some(i => this.checkedProductGroups[i]))
                          && (this.distinctProductUsages.every(i => !this.checkedProductUsages.hasOwnProperty(i) || !this.checkedProductUsages[i])
                                || product.usages.some(i => this.checkedProductUsages[i]))
              });

      },
      // see https://stackoverflow.com/a/15030117/6603778
      flatten: function (arr) {
        return arr.reduce(function (flat, toFlatten) {
            return flat.concat(Array.isArray(toFlatten) ? this.flatten(toFlatten) : toFlatten);
        }, []);
      },
      flatMap: function (f, xs) {
          return xs.map(f).reduce(this.concat, [])
      },
      concat: function(x,y) {
          return x.concat(y)
      },
      intersections: function(xs, ys) {
          const result = xs.filter(value => ys.includes(value));
          return result;
      },
      intersects: function(xs, ys) {
          return this.intersections(xs, ys).length > 0;
      },
      showAll_Clicked: function() {
          this.checkedPlantCategories.forEach(group => {
              this.checkedPlantCategories[group] = true;
          });
          this.distinctProductGroups.forEach(group => {
              this.checkedProductGroups[group] = true;
          });
          this.distinctProductUsages.forEach(usage => {
              this.checkedProductUsages[usage] = true;
          });
      },
      saveToWishlist: function(category, product) {
          const item = { category: category, product: product };
          if (!this.wishlist.some(elem => elem.product.productOrderNumber == item.product.productOrderNumber)) {
              this.wishlist.push(item);
              this.wishlist.sort((e1, e2) => e1.product.productOrderNumber < e2.product.productOrderNumber ? -1 : 1);
              this.updateWishlistText();
          }
      },
      removeFromWishlist: function(item) {
          this.wishlist = this.wishlist.filter(elem => elem.product != item.product);
          this.updateWishlistText();
      },
      updateWishlistText: function() {
          var wishlist_textarea = document.getElementById("wishlist_textarea");
          this.wishlistText = this.wishlist.map(item => {
              var customerProductNumberString;
              if (item.product.customerProductNumber != undefined) {
                  customerProductNumberString = '[' + item.product.customerProductNumber + '] ';
              } else {
                  customerProductNumberString = '';
              }
              return customerProductNumberString +  item.product.productOrderNumber + ' ' + item.product.name + ' ' + item.product.pot + ' (' + item.product.amountPerSellingUnit + ' Stk/VE)';
          }).join("\n") + "\n\nBitte beachten Sie, dass die Verfügbarkeit von Artikeln nicht immer am aktuellen Stand ist!";
          wishlist_textarea.value = this.wishlistText;
          this.wishlistText = this.wishlistText.replace(/(?:\r\n|\r|\n)/g, '%0D%0A');

      },
      isInWishlist: function(product) {
          return this.wishlist.some(elem => elem.product.productOrderNumber == product.productOrderNumber);
      },
      copyWishlist: function() {
          var copyText = document.getElementById("wishlist_textarea");

          copyText.select();

          document.execCommand("copy");

          this.wishlistCopyMessage = "Die Merkliste wurde in die Zwischenablage kopiert!"
      },
      findProductThumbnail: function(product, weekNumber) {
          let weekNumberString = ("0" + weekNumber).slice(-2);  // two digits
          let photoNumberString = "01";

          let currentImageUrl = this.url + '/images/sortiment/wochen/kw' + weekNumberString + '/thumbnails/' + product.productOrderNumber + '_' + photoNumberString + '.jpg';

          var xhr = new XMLHttpRequest();
          xhr.open('HEAD', currentImageUrl, false);
          xhr.send();

          if (xhr.status == "200") {
              console.log("image found: " + currentImageUrl);
              return currentImageUrl;
          } else {
              console.log("image not found: " + currentImageUrl);
              let symbolImageUrl = this.url + '/images/sortiment/symbolfotos/thumbnails/' + product.productOrderNumber + '_' + photoNumberString + '.jpg';
              xhr.open('HEAD', symbolImageUrl, false);
              xhr.send();
              if (xhr.status == "200") {
                  console.log("image not found: " + symbolImageUrl);
                  return symbolImageUrl;
              } else {
                  console.log("image not found (code " + xhr.status + "): " + currentImageUrl);
                  return this.noImageUrl;
              }
          }

      },
      fetchProductThumbnail2: function(product, weekNumber) {
          let weekNumberString = ("0" + weekNumber).slice(-2);  // two digits
          let photoNumberString = "01";
          let ageInWeeks = this.currentWeekNumber - weekNumber;

          let currentImageUrl = this.url + '/images/sortiment/wochen/kw' + weekNumberString + '/thumbnails/' + product.productOrderNumber + '_' + photoNumberString + '.jpg';

          fetch(currentImageUrl, { method: 'HEAD' }).then(res => {
              if (res.ok) {
                  console.log("image found: " + currentImageUrl);
                  product.thumbnail = currentImageUrl;
              } else {
                  console.log("image not found: " + currentImageUrl);
                  let symbolImageUrl = this.url + '/images/sortiment/symbolfotos/thumbnails/' + product.productOrderNumber + '_' + photoNumberString + '.jpg';


                  fetch(symbolImageUrl, { method: 'HEAD' }).then(res2 => {

                      if (res2.ok) {
                          console.log("image found: " + symbolImageUrl);
                          product.thumbnail = symbolImageUrl;
                      } else {
                          console.log("image not found: " + symbolImageUrl);
                      }

                  }).catch(err => {
                    console.log('Error:', err);
                  });
              }
          }).catch(err => {
              console.log('Error:', err);
          });


      },
      addProductDetailsImage: function(product, i, weekNumber) {

          let weekNumberString = ("0" + weekNumber).slice(-2);  // two digits
          let photoNumberString = ("0" + i).slice(-2);
          let ageInWeeks = this.currentWeekNumber - weekNumber;

          var imageUrl = this.url + '/images/sortiment/wochen/kw' + weekNumberString + '/gross/' + product.productOrderNumber + '_' + photoNumberString + '.jpg';

          var xhr = new XMLHttpRequest();
          xhr.open('HEAD', imageUrl, false);
          xhr.send();

          if (i > 9) {
              console.log("Too many images");
          } else {
              if (xhr.status == "200") {
                  console.log("image found: " + imageUrl);
                  this.productDetails.images.push({ url: imageUrl, ageInWeeks: ageInWeeks });
                  this.addProductDetailsImage(product, i + 1, weekNumber);
              } else {
                  if (i == 1 && ageInWeeks <= 4) {
                      this.addProductDetailsImage(product, 1, weekNumber - 1);
                  }
                  console.log("image not found (code " + xhr.status + "): " + imageUrl);
              }
          }
      },
      addProductDetailsSymbolImage: function(product, i) {

          let photoNumberString = ("0" + i).slice(-2);

          var imageUrl = this.url + '/images/sortiment/symbolfotos/gross/' + product.productOrderNumber + '_' + photoNumberString + '.jpg';

          var xhr = new XMLHttpRequest();
          xhr.open('HEAD', imageUrl, false);
          xhr.send();

          if (i > 30) {
              console.log("Too many images");
          } else {
              if (xhr.status == "200") {
                  console.log("image found: " + imageUrl);
                  this.productDetails.images.push({ url: imageUrl });
                  this.addProductDetailsSymbolImage(product, i + 1);
              } else {
                  console.log("image not found (code " + xhr.status + "): " + imageUrl);
              }
          }
      },
      viewImageDetails_click: function(product) {
          console.log("product: " + JSON.stringify(product));

          this.productDetails.product = product;
          this.productDetails.images = product.images;
          this.productDetails.symbolImages = product.symbolImages;

         if (this.productDetails.images.length == 0) {
             this.productDetails.images.push({ url: this.noImageUrl });
         }

          document.getElementById('currentImages-tab').click();

          if (product.symbolImages.length == 0) {
              document.getElementById('symbolImagesTabContent').classList.add('disabled');
              document.getElementById('symbolImages-tab').setAttribute('aria-disabled', 'true');
          } else {
              document.getElementById('symbolImagesTabContent').classList.remove('disabled');
              document.getElementById('symbolImages-tab').setAttribute('aria-disabled', 'false');
          }

      },
      productThumbnail: function(product) {
          return product.thumbnail != null ? product.thumbnail : "error";
      },
      jumpToSortiment: function() {
          window.location.href = "#sortiment";
      },
      jumpToCategory: function(category) {
          window.location.href = "#" + category.key;
      },
      openQuickJumpList: function() {
        // TODO solved differently, might be space for improvement
      }
  },
  computed: {
      filteredProductCategories () {

            return this.productCategories.filter(category => {

                const searchstring = this.search.toLowerCase();
                const categoryName = category.name.toLowerCase();
                const categoryFilterMatches = searchstring == '' || categoryName.includes(searchstring);

                const filteredProducts = this.filterProducts(this.products, category.key, searchstring, categoryFilterMatches);
                category.filteredProducts = filteredProducts;

                return filteredProducts.length > 0;
          });
      },
      filteredProductsCount() {
          return this.filteredProductCategories.reduce((sum, elem) => elem.filteredProducts === undefined ? sum : sum + elem.filteredProducts.length, 0);
      },
      filteredProductGroups () {
          return [...new Set(this.productCategories
                  .flatMap(category => category.filteredProducts)
                  .flatMap(product => product.productGroups))];

      },
      productGroups () {
          return [...new Set(this.products
              .flatMap(product => product.productGroups))];

      },
      filteredProductUsages () {
          return [...new Set(this.productCategories
              .flatMap(category => category.filteredProducts)
              .flatMap(product => product.usages))];

      },
      productUsages () {
          return [...new Set(this.products
                .flatMap(product => product.usages))];

      },
      filteredAdProducts () {
          let result = this.filteredProductCategories
              .flatMap(elem => elem.filteredProducts)
              .filter(elem => elem.adNew.trim().length > 0 || elem.adForSale.trim().length > 0 || elem.adSpotlight.trim().length > 0);

          return result;
      },
      adProducts () {
          let result = this.products
                    .filter(elem => elem.adNew.trim().length > 0 || elem.adForSale.trim().length > 0 || elem.adSpotlight.trim().length > 0);

          return result;
      },
      filteredNewProducts () {
          let result = this.filteredProductCategories
              .flatMap(elem => elem.filteredProducts)
              .filter(elem => elem.adNew.trim().length > 0);

          return result;
      },
      newProducts () {
          let result = this.products
                    .filter(elem => elem.adNew.trim().length > 0);

          return result;
      },
      filteredForSaleProducts () {
          return this.filteredProductCategories
              .flatMap(elem => elem.filteredProducts)
              .filter(elem => elem.adForSale.trim().length > 0);
      },
      forSaleProducts () {
          return this.products
                    .filter(elem => elem.adForSale.trim().length > 0);
      },
      filteredSpotlightProducts () {
          return this.filteredProductCategories
              .flatMap(elem => elem.filteredProducts)
              .filter(elem => elem.adSpotlight.trim().length > 0);
      },
      spotlightProducts () {
          return this.products
                    .filter(elem => elem.adSpotlight.trim().length > 0);
      },
      orderedWishlistProducts () {
          if (this.wishlist === undefined) {
              return [];
          } else {
              return this.wishlist;     // already sorted when elements added to wishlist
          }
      }
  },
  created() {

      if (process.env.NODE_ENV == 'development') {
          this.url = "https://hoeller-gartenbau.at"
      } else if (process.env.NODE_ENV == 'production') {
        this.url = "https://hoeller-gartenbau.at"
          // process.env.BASE_URL  for subdomains?
      }

      this.noImageUrl = this.url + '/images/sortiment/missing-image-thumbnail.png';

      console.log(this.productGroups);
      console.log(this.checkedProductGroups);
      console.log(this.checkedPlantCategories);
      this.currentWeekNumber = this.getWeekNumber(new Date());  //31;

      const uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);

      this.customerLink = params.get("c");
  },

  mounted() {

      this.$api
          .get('/products/customer-specifics/' + this.customerLink)
          .then(response => {
              this.customerProductSpecifics = response.data;
              console.log("loaded " + Object.keys(this.customerProductSpecifics).length + " customer specifics");
          }).catch(err => {
              console.log(err);
          });

    this.$api
        .get('/product-categories')
        .then(response => {

            this.productCategories = response.data;
            console.log("loaded " + this.productCategories.length + " categories");

            this.productCategories.forEach(category => category.filteredProducts = []); // category.products
            this.productCategories.sort((e1, e2) => {
                if (e1.order != e2.order) {
                    return e1.order - e2.order;
                } else {
                    if (e1.name < e2.name) {
                        return -1;
                    } else {
                        return 1;
                    }
                }
            });

        }).catch(err => {
            console.log(err);
        });

      this.$api
          .get('/products')
          .then(response => {
              this.products = response.data;
              console.log("loaded " + this.products.length + " products");

              this.distinctPlantCategories = [...new Set(this.products
                  .map(product => product.plantCategory))]; //this.productGroups();
              this.distinctProductGroups = [...new Set(this.products
                  .flatMap(product => product.productGroups))]; //this.productGroups();
              this.distinctProductUsages = [...new Set(this.products
                  .flatMap(product => product.usages))]; //this.productUsages();
              this.distinctPots = [...new Set(this.products
                  .map(product => product.pot))];
              this.distinctSeeds = [...new Set(this.products
                  .map(product => product.seed))];

              this.distinctPlantCategories.sort();

        });



    }

  
}
</script>

<style scoped>
    .productCatalog {
        background: rgba(46,139,87,1.0);
    }

    .primaryHeading {
        color: #eeeeee;
        font-size: 24px;
    }

    .searchHeading{
        height: 50px;
        line-height: 50px;
        padding-left: 10px;
        position: -webkit-sticky;
        top: 0px;
    }
    .searchHeadingPlaceholder{
        height: 70px;
    }

    .productGroupHeading{
        background: rgba(255, 255, 255, 0.7);
        height: 50px;
        line-height: 50px;
        margin-top: 10px;
        font-size: 30px;
        padding-left: 10px;
        padding-right: 10px;
        position: -webkit-sticky;
        position: sticky;
        top: 70px;
        z-index: 1;
        border-radius: 4px;
    }

    .productCard {
        background: rgba(255,255,255,0.7);
        margin-top: 10px;
        margin-bottom: 10px;
        padding: 8px;
        border-radius: 10px;
        border: 2px solid #AACCAA;
    }

    .productName {
        /*background: green;*/
        margin-bottom: -10px;
        padding-bottom: 0px;
    }

    .productMainInfoLine {
        /*background: blue;*/
    }
    .botanicName {
        font-size: 10px;
        /*background: red;*/
    }

    .wishlist {
        background: rgba(240, 240, 240, 0.5);
        height: 90vh;
        margin-top: 10px;
        position: -webkit-sticky;
        position: sticky;
        top: 70px;
        overflow-y: scroll;
        border-radius: 10px;
        padding: 10px;
    }

    .wishlistItem {
        margin-top: 10px;
        margin-bottom: 10px;
        background: rgba(255,255,255,0.4);
        border-radius: 5px;
        min-height: 45px;
        padding: 4px;
    }

    .wishlistItem button {
        margin-top: 2px;
        margin-bottom: 2px;
        margin-right: 5px;
        float: left;
    }

    .filterPanel {
        background: rgba(230, 230, 230, 0.4);
        padding: 8px;
        border-radius: 10px;
    }

    .imageCaption {
        background: rgba(230, 230, 230, 0.7);
    }

    .imageCaption.warning {
        background: rgba(255, 255, 0, 0.5) !important;
    }

    .imageCaptionHeading {
        color: rgba(40, 40, 40, 0.8);
    }

    .imageCaptionText {
        color: rgba(40, 40, 40, 0.8);
    }

    .imageAgeWeek {
        font-size: larger;
        font-weight: bold;
    }

    .newProductText {
        font-weight: bolder;
        color: #007700;
    }

    .spotlightProductText {
        font-weight: bolder;
    }

    .forSaleProductText {
        font-weight: bolder;
        color: #900000;
    }

    .newProductCard {
        margin: 10px;
    }

    .spotlightProductCard {
        margin: 10px;
    }

    .forSaleProductCard {
        margin: 10px;
    }

    .newProductHeader {
        background: rgba(255, 255, 255, 0.7);
        height: 50px;
        line-height: 50px;
        margin-top: 20px;
        font-size: 30px;
        padding-left: 10px;
        padding-right: 10px;
        position: -webkit-sticky;
        position: sticky;
        top: 70px;
        z-index: 1;
    }

    .spotlightProductHeader {
        background: rgba(255, 255, 255, 0.7);
        height: 50px;
        line-height: 50px;
        margin-top: 20px;
        font-size: 30px;
        padding-left: 10px;
        padding-right: 10px;
        position: -webkit-sticky;
        position: sticky;
        top: 70px;
        z-index: 1;
    }

    .forSaleProductHeader {
        background: rgba(255, 255, 255, 0.7);
        height: 50px;
        line-height: 50px;
        margin-top: 20px;
        font-size: 30px;
        padding-left: 10px;
        padding-right: 10px;
        position: -webkit-sticky;
        position: sticky;
        top: 70px;
        z-index: 1;
    }

    .sortimentHeader {
        color: #eeeeee;
        font-size: 24px;
    }

    .availabilityGood {
        color: green;
        font-weight: bold;
        font-size: 20px;
    }

    .availabilityWarning {
        color: #aaaa00;
        font-weight: bold;
        font-size: 20px;
    }

    .availabilitySoon {
        color: dodgerblue;
        font-weight: bold;
        font-size: 20px;
    }

    .availabilitySoldOut {
        color: red;
        font-weight: bold;
        font-size: 20px;
    }

    .availabilityOffSeason {
        color: red;
        font-weight: bold;
        font-size: 20px;
    }

    .availabilitySeason {
        color: red;
    }

    .productCardImage {
        min-height: 50px;
    }

    .productCardLeftPanel {
        min-width: 216px; /* TODO correct? */
    }

    .productFilterCountText {
        font-size: 10px;
    }

    .productButtonsPanel {
        margin-top: 8px;
    }

    .productOrderNumberPanel {
        text-align: center;
        padding: 12px;
        padding-bottom: 0px;
    }

    .productOrderNumberPanelNumber {
        font-size: 28px;
        margin-bottom: 0px;
        padding-bottom: 0px;
    }

    .customerProductNumberPanel {
        text-align: center;
        padding: 12px;
        padding-bottom: 0px;
    }

    .customerProductNumberPanelNumber {
        font-size: 22px;
        margin-bottom: 0px;
        padding-bottom: 0px;
    }

    .eanPanel {
        text-align: center;
        padding: 12px;
        padding-bottom: 0px;
    }

    .eanPanelNumber {
        font-size: 22px;
        margin-bottom: 0px;
        padding-bottom: 0px;
    }


    .potSeedProductGroupsSeparator {
        color: #aaaaaa;
    }

    .productCardRow {
        margin-top: 4px;
        margin-bottom: 6px;
    }

    .productCardLabel {
        color: #666666;
        font-size: 12px;
    }

    .productCardInfo {
        font-size: 16px;
    }

    .productCardInfoAvailability {
        font-size: 18px;
    }

    .productCardNumberLabel {
        color: #666666;
        font-size: 14px;
    }

    .productCardImage {
    }

    .productCardImage:hover {
        opacity: 1.0;
        filter: alpha(opacity=100); /* For IE8 and earlier */
    }

    .carousel .item img {
        max-height: 70vh;
        min-width: auto;
        margin-left: auto;
        margin-right: auto;
    }

    .productDetailsImage {
        max-height: 70vh;
        max-width: 70vh;
        min-width: auto;
        margin-left: auto;
        margin-right: auto;
    }

    .productDetailsImageHolder {
        background: black;
    }
    
    .productCardContent {
        width: 100%;
    }

    .imageDetailsNavButton {
    }

    .navIcon {
    }

    ol.carousel-indicators li.active {
    }

    .navbar {
        top: 2px;
        border-radius: 10px;
    }

    .searchTextfield {
        margin-left: 5px;
    }

    .mainBanner {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 60%;
        margin-top: 50px;
        margin-bottom: 50px;
        border-top-left-radius: 50px;
        border-bottom-right-radius: 50px;
    }

    .gardneryImage {
        max-height: 30vh;
        display: block;
        margin-left: auto;
        margin-right: auto;
        margin-top: 50px;
        margin-bottom: 50px;
        border-radius: 30px;
    }
    
    .quickJumpProductCount {
        color: gray;
    }

    .quickJumpProductFirstLetter {
        font-weight: bold;
        font-size: x-large;
    }

    a.anchor {
        display: block;
        position: relative;
        top: -70px;
        visibility: hidden;
    }


    .productButtonsPanel button {
        margin-right: 3px;
    }

    .wishlistButtonsPanel button {
        margin-right: 3px;
        margin-bottom: 3px;
    }

     .dropdown-btn {
  padding: 6px 8px 6px 16px;
  text-decoration: none;
  font-size: 20px;
  color: #818181;
  display: block;
  border: none;
  background: none;
  width:100%;
  text-align: left;
  cursor: pointer;
  outline: none;
}

.dropdown-container {
  display: none;
  background-color: #262626;
  padding-left: 8px;
}

</style>
